<div class="modal-header">
	<h5 class="modal-title">Sammelbearbeitung – Verlauf</h5>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="cancel()"></button>
</div>

<div class="modal-body">
	<p class="text-muted small">
		Die letzten Sammelbearbeitungen aus dem Verlauf der {{ points.length }} geladenen Punkte (max. 50).
		Klicke „Rückgängig", um eine Sammelbearbeitung auf allen betroffenen Punkten zurückzurollen.
	</p>

	<div *ngIf="summaries.length === 0" class="alert alert-info">
		Keine Sammelbearbeitungen im Verlauf dieser Punkte gefunden.
	</div>

	<!-- Undo-Fortschritt -->
	<div *ngIf="runningUndoId" class="alert alert-warning">
		<div class="d-flex justify-content-between align-items-center">
			<strong>Rückgängig läuft…</strong>
			<span class="small text-muted">{{ progressDone }} / {{ progressTotal }}</span>
		</div>
		<ngb-progressbar type="warning"
						 [value]="progressTotal ? (progressDone / progressTotal * 100) : 0"
						 [animated]="true" [striped]="true"></ngb-progressbar>
		<div class="small text-muted mt-1">Aktueller Punkt: {{ currentPointId }}</div>
	</div>

	<!-- Abschlussbericht des letzten Undo -->
	<div *ngIf="report && !runningUndoId" class="alert alert-success">
		Rückgängig abgeschlossen: {{ report.changedPoints }} von {{ report.totalPoints }} Punkten rückgängig gemacht.
		<span *ngIf="report.errors.length > 0" class="text-danger"> · {{ report.errors.length }} Fehler.</span>
	</div>

	<!-- Historie-Tabelle -->
	<table *ngIf="summaries.length > 0" class="table table-sm history-table">
		<thead>
			<tr>
				<th>Zeit</th>
				<th>Beschreibung</th>
				<th>Initiator</th>
				<th class="text-end">Betroffen</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let s of summaries" [class.row-revert]="isRevert(s)">
				<td class="small">{{ formatTimestamp(s.timestamp) }}</td>
				<td>
					<span *ngIf="isRevert(s)" class="badge bg-secondary me-1" title="Revert-Eintrag">↶ Undo</span>
					{{ s.label || '(ohne Label)' }}
					<div class="text-muted small">
						<code>{{ s.batchId }}</code>
					</div>
				</td>
				<td class="small">{{ s.user || '—' }}</td>
				<td class="text-end">{{ s.affectedCount }}</td>
				<td class="text-end">
					<button type="button"
							class="btn btn-sm btn-outline-warning"
							[disabled]="!!runningUndoId || isRevert(s) || !canUndo(s)"
							[title]="isRevert(s) ? 'Revert-Einträge können nicht erneut rückgängig gemacht werden' : (!canUndo(s) ? 'Nur der Ersteller der Sammelbearbeitung (oder Eigentümer/Manager) kann sie rückgängig machen' : 'Sammelbearbeitung auf allen betroffenen Punkten rückgängig machen')"
							(click)="undoBatch(s)">
						Rückgängig
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-primary" [disabled]="!!runningUndoId" (click)="close()">
		Schließen
	</button>
</div>
